import { CollectionPrinter, Div } from '@tblabs/truffle';
import { Translations } from '../../Translations/Translations';
import { TitleRow } from '../../Components/Snapshots/TitleRow';
import { Row } from '../../Components/General/Row';
import { IoLogic } from '../IoLogic';
import { ICamera } from '../../Services/Camera/ICamera';
import { TouchButton } from '../../Components/General/Buttons/TouchButton';


export class Vibra
{
    constructor(private _camera: ICamera, public Id: string, public Name: string)
    { }

    public SetValue(value: number): void
    {
        this._camera.SetOutput(this.Id, value);
    }
}

export class VibraBox extends Div
{
    constructor(private vibra: Vibra)
    {
        super();

        this.Append(
            new TouchButton(this.vibra.Name, () => vibra.SetValue(1), () => vibra.SetValue(0)),
        )
    }
}

export class VibrasBox extends Div
{
    constructor(private _logic: IoLogic, private _lang: Translations)
    {
        super("");

        this.MarginTop(16);

        this.Append(
            new TitleRow(this._lang.Communication),
            new Row(
                new CollectionPrinter(this._logic.Vibrators, vibra => new VibraBox(vibra))
            ).Class("sensors"),
        );
    }
}
